// Dependencias
import Api from '@/services/Api'
// methods
export default {
  fetchUser (token) {
    return Api().get('users', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  addUser (params, token) {
    return Api().post('users', params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  getUser (params, token) {
    return Api().get('users/' + params.id, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  editUser (params, token) {
    return Api().put('users/' + params.id, params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  delUser (params, token) {
    return Api().delete('users/' + params.id, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  changePassword (params, token) {
    return Api().post('changepassword', params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  }
}



// WEBPACK FOOTER //
// ./src/services/UsersService.js